import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MappaComponent } from "../../mappa/mappa.component";
import { GestioneUtentiService } from "src/app/servizi/utenti/gestione-utenti.service";
import { MappaService } from "src/app/servizi/mappa/mappa.service";
import { ConfigService } from "src/app/servizi/config/config.service";
import FUNZIONALITA from "src/app/servizi/EBWIdFunzionalita";
import { transform } from 'ol/proj';

import * as FileSaver from "file-saver";
import { DownloadService } from "src/app/servizi/download.service";
import { RouterService } from "src/app/servizi/router.service";
import { UtilsService } from "src/app/servizi/utils.service";
import { ReportBtsComponent } from "src/app/modali/report-bts/report-bts.component";

/** Primary Left-side Menù */
@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.scss"],
  providers: [NgbModal, MappaComponent],
})
export class MenuComponent implements OnInit {

  @Output() toggle: EventEmitter<any> = new EventEmitter();
  /** Template files */
  EMPTY_FILENAME = "empty_template.csv";
  EXAMPLE_FILENAME = "example_template.csv";
  EXAMPLE_PIXEL_FILENAME = "pixel_sample.json";

  public templateDir;
  public emptyTemplatePath;
  public exampleTemplatePath;
  public pixelTemplatePath;

  public solrCore;

  /** Icons FA */
  icons: any = {
    faSearch,
  };

  /** Constructor */
  constructor(
    private gestioneUtentiService: GestioneUtentiService,
    private mappaService: MappaService,
    private configService: ConfigService,
    private downloads: DownloadService,
    private routerSrv: RouterService,
    private utils: UtilsService,
    private modal: NgbModal
  ) {
    this.solrCore = this.configService.getConfigGlobale().solr.core.menu;
    this.templateDir = this.configService.getConfigGlobale().download.template_dir;


  }

  /** ngOnInit */
  ngOnInit() {
    this.emptyTemplatePath = `${this.templateDir}/${this.EMPTY_FILENAME}`;
    this.exampleTemplatePath = `${this.templateDir}/${this.EXAMPLE_FILENAME}`;
    this.pixelTemplatePath = `${this.templateDir}/${this.EXAMPLE_PIXEL_FILENAME}`;

  }

  /** Solr autocomplete component: to format list items */
  resultFormatter = (doc) => (doc.description);

  /** Solr autocomplete component: to format input items */
  inputFormatter = (doc) => (doc.description);

  /**
   * Function used to check if a menu item must be shown
   * @param {string} which menu item
   */

  public isMenuVisible(which: string): boolean {
    switch (which) {
      case "home":
        return this.gestioneUtentiService.isEnabled(this.configService.getConfigGlobale().permissions.mainMenuControls.mainMenuHome);
      case "analisi":
        return this.gestioneUtentiService.isEnabled(this.configService.getConfigGlobale().permissions.mainMenuControls.mainMenuAnalisi);
      case "gestione_analisi":
        return this.gestioneUtentiService.isEnabled(this.configService.getConfigGlobale().permissions.mainMenuControls.mainMenuGestioneAnalisi);
      case "gestione_analisi_massiva":
        return this.gestioneUtentiService.isEnabled(this.configService.getConfigGlobale().permissions.mainMenuControls.mainMenuGestioneAnalisiMassiva);
      case "analisi_visibilita":
        return this.gestioneUtentiService.isEnabled(this.configService.getConfigGlobale().permissions.mainMenuControls.mainMenuAnalisiVisibilita);
      case "ricerca_analisi":
        return this.gestioneUtentiService.isEnabled(this.configService.getConfigGlobale().permissions.mainMenuControls.mainMenuRicercaAnalisi);
      case "itemTest":
        return this.gestioneUtentiService.isEnabled(this.configService.getConfigGlobale().permissions.mainMenuControls.mainMenuItemTest);
      case "subitemTest":
        return this.gestioneUtentiService.isEnabled(this.configService.getConfigGlobale().permissions.mainMenuControls.mainMenuSubitemTest);
      case "searchBar":
        return this.gestioneUtentiService.isEnabled(this.configService.getConfigGlobale().permissions.mainMenuControls.mainMenuSearchBar);
      case "download":
        return this.gestioneUtentiService.isEnabled(this.configService.getConfigGlobale().permissions.mainMenuControls.mainMenuDownload);
      case "empty_template":
        return this.gestioneUtentiService.isEnabled(FUNZIONALITA.MAIN_MENU_CONTROLS.MAIN_MENU_DOWNLOAD_EMPTY_T);
      case "example_template":
        return this.gestioneUtentiService.isEnabled(this.configService.getConfigGlobale().permissions.mainMenuControls.mainMenuDownloadExampleT);
      case "export_csv":
        return this.gestioneUtentiService.isEnabled(FUNZIONALITA.MAIN_MENU_CONTROLS.MAIN_MENU_EXPORT_CSV);
      case "pixel_template":
        return this.gestioneUtentiService.isEnabled(FUNZIONALITA.MAIN_MENU_CONTROLS.MAIN_MENU_DOWNLOAD_PIXEL_T);



      default:
        return false;
    }
  }

  onMenuToggle() {
    this.toggle.emit(null);
  }

  /** 
   * To close the Sidebar before opening the RightSidebar
   */
  toggleSidebarAnalysis() {
    this.toggle.emit(null);
    this.mappaService.toggleSidebar.next(true);
  }

  // toggleSidebarAnalysis(size?){
  //   this.mappaService.toggleSidebar.next({toggle: true, size: size})
  // } 


  /** File Download (Client-side)*/
  download(source, dest): void {
    this.downloads
      // .download(source)
      .download(source)
      .subscribe(blobData => {

        /** 
         * https://github.com/eligrey/FileSaver.js/issues/28
         * For all your special character needs, just use UTF-8, but additionally add a BOM to make sure the file is opened correctly.
         * CSV for example was opened by Office Excel versions prior to Office 2007 with the wrong ANSI 1252 encoding by default.
         * Adding a BOM will make the file open correctly (in UTF-8) in Office versions since Office 2007 (maybe needs Office SP for Office 2007)
         */

        // let blob = new Blob ([blobData], { type: "text/plain;charset=utf-8" });
        // FileSaver.saveAs(blob, dest);


        var file = new File([blobData], dest, { type: "text/plain;charset=utf-8" });
        FileSaver.saveAs(file);


      })
  }

  selectedSearchItem(event: any) {
    // console.log("selectedSearchItem", event)
    // event = {
    //   "url":"G4BrefVrecordVdatasetZINWITVcollectionZBTSVkeysZI025BN",
    //   "type":"BTS",
    //   "description":"I025BN S. Marco Dei Cavoti Via A. De Gasperi C/0 C.Le Telecom Italia,S.N.C. San Marco Dei Cavoti",
    //   "_version_":1721774796717424600,
    //   "content":{
    //     "owner":"Inwit",
    //     "zona":"SUD",
    //     "descrizione":"I025BN S. Marco Dei Cavoti Via A. De Gasperi C/0 C.Le Telecom Italia,S.N.C. San Marco Dei Cavoti",
    //     "cap":"82029",
    //     "vodafone_id":"4RM00717",
    //     "lon":"14.8801556",
    //     "inwit_id":"I025BN",
    //     "id":"I025BN",
    //     "regione":"Campania",
    //     "lat":"41.3134667",
    //     "tim_id":"BNT036"
    //   },
    //   "tag":[],
    //   "position":"41.3134667, 14.8801556"
    // }

    let dataset = event.url.split('V')[2].split('Z')[1]
    let collection = event.url.split('V')[3].split('Z')[1]
    let id = event.url.split('V')[4].split('Z')[1]

    switch (collection) {
      case "BTS":
      case "bts":
        const coordinate = transform(
          [Number(event.content.lon), Number(event.content.lat)],
          "EPSG:4326",
          "EPSG:3857"
        );

        let geometry = { "type": "Point", "coordinates": coordinate }

        const mapData = {
          mapAction: 'fit', //  Per Centrare la mappa sulla geometria
          geom: geometry, // La mappa farà il fit sulla geometria dell'atto
          controlliMappaAttivi: true
        };

        // Chiusura pagina ricerca apertura Mappa
        this.routerSrv.navigateToChild('mappa', mapData);
        break;
    }
  }

  selectedSearchItemClick(event: any) {
    // console.log("selectedSearchItemClick", event);

    var params = { "urn": event.url.toString() };

    var url = this.utils.creaURL("restrictedArea", "reportByUrn");

    this.utils.getRequest(url, params)
      .subscribe(response => {
        // console.log("response", response);

        const bts_report = this.modal.open(ReportBtsComponent, {
          ariaLabelledBy: 'modal-basic-title',
          centered: true,
          size: 'md'
        });

        bts_report.componentInstance.obj = response;
        bts_report.componentInstance.id = event.url.toString();
      })
  }
}